// extracted by css-extract-rspack-plugin
export default {"wrapper":"TableSection_wrapper__8q+Ar","table":"TableSection_table__eOUpo"};